export const errorMessage = 'Failed to delete an user saved project from perseus';
